
// @ts-nocheck


export const localeCodes =  [
  "en",
  "en-US",
  "en-GB",
  "en-IN",
  "en-NG",
  "es",
  "es-MX",
  "pt-BR",
  "en-XX"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en/main.json", load: () => import("../lang/en/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_en_main_json" */), cache: true }],
  "en-US": [{ key: "../lang/en/main.json", load: () => import("../lang/en/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_en_main_json" */), cache: true }],
  "en-GB": [{ key: "../lang/en/main.json", load: () => import("../lang/en/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_en_main_json" */), cache: true }],
  "en-IN": [{ key: "../lang/en/main.json", load: () => import("../lang/en/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_en_main_json" */), cache: true }],
  "en-NG": [{ key: "../lang/en/main.json", load: () => import("../lang/en/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_en_main_json" */), cache: true }],
  "es": [{ key: "../lang/es/main.json", load: () => import("../lang/es/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_es_main_json" */), cache: true }],
  "es-MX": [{ key: "../lang/es/main.json", load: () => import("../lang/es/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_es_main_json" */), cache: true }],
  "pt-BR": [{ key: "../lang/pt-BR/main.json", load: () => import("../lang/pt-BR/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_pt_BR_main_json" */), cache: true }],
  "en-XX": [{ key: "../lang/xxa/main.json", load: () => import("../lang/xxa/main.json" /* webpackChunkName: "locale__home_runner_work_rediredi_storefront_rediredi_storefront_lang_xxa_main_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "files": [
        "lang/en/main.json"
      ]
    },
    {
      "code": "en-US",
      "files": [
        "lang/en/main.json"
      ]
    },
    {
      "code": "en-GB",
      "files": [
        "lang/en/main.json"
      ]
    },
    {
      "code": "en-IN",
      "files": [
        "lang/en/main.json"
      ]
    },
    {
      "code": "en-NG",
      "files": [
        "lang/en/main.json"
      ]
    },
    {
      "code": "es",
      "files": [
        "lang/es/main.json"
      ]
    },
    {
      "code": "es-MX",
      "files": [
        "lang/es/main.json"
      ]
    },
    {
      "code": "pt-BR",
      "files": [
        "lang/pt-BR/main.json"
      ]
    },
    {
      "code": "en-XX",
      "files": [
        "lang/xxa/main.json"
      ]
    }
  ],
  "defaultLocale": "pt-BR",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "lang",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "files": [
      {
        "path": "lang/en/main.json"
      }
    ]
  },
  {
    "code": "en-US",
    "files": [
      {
        "path": "lang/en/main.json"
      }
    ]
  },
  {
    "code": "en-GB",
    "files": [
      {
        "path": "lang/en/main.json"
      }
    ]
  },
  {
    "code": "en-IN",
    "files": [
      {
        "path": "lang/en/main.json"
      }
    ]
  },
  {
    "code": "en-NG",
    "files": [
      {
        "path": "lang/en/main.json"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "lang/es/main.json"
      }
    ]
  },
  {
    "code": "es-MX",
    "files": [
      {
        "path": "lang/es/main.json"
      }
    ]
  },
  {
    "code": "pt-BR",
    "files": [
      {
        "path": "lang/pt-BR/main.json"
      }
    ]
  },
  {
    "code": "en-XX",
    "files": [
      {
        "path": "lang/xxa/main.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
